<template>
    <div v-if="user">
        <report-window
            v-if="ready"
            endpoint="/reports/tickets_list"
            :fields="fields"
            :title="title"
            :headers="headers"
            :current.sync="current"
            :columnClick="columnClick"
            :templates="templates"
            :columnsClasses="columnsClasses"
            :updateReport="updateReport"
            :perPage="(options && options.perPage)? options.perPage: 500"
            :hideFilters="false"
            :runMounted="options && options.runMounted"
            :fieldClasses="fieldClasses"
            :cardView="options && options.cardView"
            :notFilterable="options && options.notFilterable"
            :headerColumns="options? options.headerColumns: null"
            :buttons="buttons"
            :rowClassFunction="rowClassFunction"
            ></report-window>
        <ticket-comments
            v-if="ticketId || newTicket"
            :id.sync="ticketId"
            :newTicket.sync="newTicket"
        ></ticket-comments>
    </div>
</template>

<script>
import ReportWindow from "@/components/tools/ReportWindow";
import ticketComments from '@/components/tools/TicketComments';
import { mapState } from "vuex";
export default {
    name: "tickets-list-report",
    props: ['options', 'cardTitle'],
    components: {
        ReportWindow,
        'ticket-comments': ticketComments
    },
    computed:{
        ...mapState({
            user: state => state.main.user,
        }),
    },
    async mounted () {
        frontTools.setReportValues(this);
        this.fields = Object.assign([], this.fields);
        this.ready = true;
    },
    data () {
        return {
            current: {},
            updateReport: false,
            newTicket: false,
            ticketId: null,
            ready: false,
            fields: [
                {name: 'CustomerId', label: 'Customer', editor: 'vue-select', addBlank: true,
                    optionLabels: 'Name', relation: 'customer', list: true,
                },
                {name: 'TicketTypeId', label: 'Type', editor: 'vue-select', addBlank: true,
                    optionLabels: 'Name', relation: 'tickettype',
                },
                {name: 'Status', label: 'Status', editor: 'select', addBlank: true,
                    options: [
                        { label: 'All', value: 'ALL'},
                        { label: 'Open', value: 'OPEN'},
                        { label: 'Closed', value: 'CLOSED'},
                    ]
                },
                {name: 'AssignedUserId', label: 'Assigned To', editor: 'vue-select', addBlank: true,
                    optionLabels: 'UserName', relation: 'user',
                },
                {name: 'LastModifiedBy', label: 'Last Modified By', editor: 'vue-select', addBlank: true,
                    optionLabels: 'UserName', relation: 'user',
                },
                {name: 'Priority', label: 'Priority', editor: 'select', addBlank: true,
                    options: [
                        { label: 'All', value: 'ALL'},
                        { label: 'Low', value: 'LOW'},
                        { label: 'Medium', value: 'MEDIUM'},
                        { label: 'High', value: 'HIGH'},
                        { label: 'Critical', value: 'CRITICAL'},
                    ]
                },
                {name: 'ProjectId', label: 'Project', editor: 'vue-select', addBlank: true,
                    optionLabels: 'Name', relation: 'project',
                },
                { name: 'FromDate', label: 'From Date', editor: 'date',},
                { name: 'ToDate', label: 'To Date', editor: 'date'},
            ],
            title: "Tickets List",
            headers: {
            },
            templates: [
                { name: 'CreatedAt', callback: (row) => {
                    return moment(row.CreatedAt).format('DD/MM/YYYY HH:mm');
                }},
                { name: 'ModifiedAt', callback: (row) => {
                    return moment(row.ModifiedAt).format('DD/MM/YYYY HH:mm');
                }},
            ],
            columnClick: {
                TicketId: (row) => {
                    this.ticketId = row.TicketId;
                    //this.$root.$children[0].openModalRecord({modalRecord: null, modalTable: 'ticket', modalId: row.TicketId});
                }
            },
            columnsClasses: {
                TicketId: 'cursor-pointer-report',
            },
            buttons: [
                {
                    icon: 'plus',
                    disabled: false,
                    buttonClass: 'btn btn-primary',
                    cardView: true,
                    id: 'new-ticket',
                    callback: (row) => {
                        this.newTicket = true;
                    },
                },
            ],
            fieldClasses: {
                LimitDate: (row) => {
                    if (row.LimitDate) {
                        const limitDate = moment(row.LimitDate);
                        const today = moment();
                        const daysUntilLimit = limitDate.diff(today, 'days');
                        if (daysUntilLimit < 0) {
                            return 'text-danger';
                        }
                        if (daysUntilLimit <= 3) {
                            return 'text-warning';
                        }
                    }
                    return '';
                },
            },
            rowClassFunction: (row) => {
                if (row.Billable) {
                    return 'bg-darkgray';
                }
                return '';
            }

        };
    },
    methods: {
    }
};
</script>

<style>
.bg-darkgray {
    background-color: darkgray !important;
}
</style>